<template>
  <nav
    class="navbar is-primary"
    role="navigation"
    aria-label="main navigation"
    style="margin-bottom: 12px;"
  >
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img
          src="~/assets/images/missoni_logo_black.png"
          alt="Missoni"
          width="112"
          height="28"
        />
      </a>
    </div>

    <div class="navbar-menu">
      <div class="navbar-start">
        <nuxt-link
          v-for="{ id, path } in visibleMenuItems()"
          :key="id"
          class="navbar-item"
          :to="path"
        >
          {{ $t(`topNavbar.items.${id}`) }}
        </nuxt-link>
      </div>

      <div class="navbar-end">
        <div v-if="mediaSharable > 0" class="navbar-item px-0 py-0 mr-4">
          <a class="navbar-link is-arrowless" @click="onShareImagesClick">
            <span v-if="mediaSharable" class="badge is-light is-right">
              {{ mediaToShareCount }}
            </span>
            <span class="icon">
              <fa-icon :icon="['fas', 'envelope']" />
            </span>
            <span>
              {{ $t('topNavbar.share_images_cart') }}
            </span>
          </a>
        </div>
        <v-popover offset="8" trigger="hover" placement="bottom" :open.sync="batchesScheduleVisible">
          <!-- This will be the popover target (for the events and position) -->
          <div class="tooltip-target navbar-item px-0 py-0">
            <a class="navbar-link is-arrowless">
              <span class="icon">
                <fa-layers class="fa-stack">
                  <fa-icon :icon="['fas', 'cloud-download-alt']" transform="left-6 up-4 shrink-4" />
                  <fa-icon :icon="['far', 'clock']" transform="right-4 down-2" />
                </fa-layers>
              </span>
            </a>
          </div>

          <!-- This will be the content of the popover -->
          <template slot="popover">
            <batches-schedules :is-visible="batchesScheduleVisible" />
          </template>
        </v-popover>

        <div class="navbar-item px-0 py-0">
          <a
            :href="$env.supportUrl"
            :title="$t('navbar.supportUrlTitle')"
            target="_blank"
            class="navbar-link is-arrowless"
          >
            <span class="icon">
              <fa-icon :icon="['far', 'life-ring']" />
            </span>
          </a>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link is-arrowless">
            <span class="icon" style="margin-right: 4px">
              <fa-icon :icon="['fas', 'user']" />
            </span>
            {{ user.name || user.email }}
          </a>
          <div class="navbar-dropdown is-right">
            <a class="navbar-item" @click="onShowSearchesStatusClick">
              {{ $t('topNavbar.searches_status') }}
            </a>
            <a class="navbar-item" @click="userChangePasswActive = true">
              {{ $t('topNavbar.change_password') }}
            </a>
            <a 
              v-if="canSeeAdminLink" 
              class="navbar-item" 
              target="blank"
              :href="$env.backofficeUrl"
            >
              {{ $t('topNavbar.administration_panel') }}
            </a>
            <a class="navbar-item" href="#!" @click="logout">
              {{ $t('topNavbar.logout') }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <change-user-passw-modal
      v-if="userChangePasswActive"
      :active.sync="userChangePasswActive"
      @cancel="closeDialog"
      @confirm="closeDialog"
    />

    <searches-status-modal v-if="searchesStatusModalVisible" @close="onShowSearchStatusClose" />
  </nav>
</template>
<script>
import { mapGetters } from 'vuex'
import { canNavigateTo, canNavigateToAdmin } from '@/utils/user_authorization'
import ChangeUserPasswModal from "@/components/ChangeUserPasswModal.vue"
import { purgeMediaListFromLocalStorage } from '@/store/share_images_cart'
import BatchesSchedules from './BatchesSchedules.vue'
import SearchesStatusModal from '@/components/SearchesStatusModal'

export default {
  name: 'TopNavbar',
  components: {
    ChangeUserPasswModal,
    BatchesSchedules,
    SearchesStatusModal
  },
  props: {
    isPreview: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      userChangePasswActive: false,
      batchesScheduleVisible: false,
      searchesStatusModalVisible: false
    }
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
      mediaToShareCount: 'share_images_cart/mediaCount'
    }),
    user() { return this.loggedUser || {} },
    canSeeAdminLink() { return canNavigateToAdmin(this.user.roles) },
    mediaSharable() { return this.mediaToShareCount > 0 }
  },
  methods: {
    menuItems() {
      return [
        { id: 'editorials', path: '/editorials' },
        { id: 'manual_input', path: '/manual_input' },
        { id: 'instagram', path: '/instagram' },
        { id: 'advanced_search', path: '/advanced_search' },
        { id: 'resource_notifications', path: '/resource_notifications' }
      ]
    },
    visibleMenuItems() {
      return this.isPreview ? [{ id: 'preview', path: '' }] :
                              this.menuItems().filter(({ path }) => this.canSeeLink(path))
    },
    logout() {
      this.$nuxt.$loading.start()
      this.$repositories()
          .auth
          .logout()
          .then(purgeMediaListFromLocalStorage)
          .then(() => this.$nuxt.$loading.finish())
          .then(() => this.$router.push('/login'))
    },
    canSeeLink(link) { return canNavigateTo(this.user.roles, link) },
    closeDialog() { this.userChangePasswActive = false },
    onShareImagesClick() {
      if (!this.mediaSharable) return

      this.$store.dispatch('share_images_cart/openCart')
    },
    onShowSearchesStatusClick() { this.searchesStatusModalVisible = true },
    onShowSearchStatusClose() { this.searchesStatusModalVisible = false }
  }
}
</script>
<style lang="scss">
.navbar-link.is-disabled {
  cursor: not-allowed;
}
</style>